const StatusIcon = () => (
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mr-4"
  >
    <rect y="0.187683" width="8" height="8" rx="4" fill="#2F9E44" />
  </svg>
);

export default StatusIcon;
